'use strict';
var React = require('react');
var ShapeParts = require('../common/ShapeParts');
var IconParts = require('../common/IconParts');
var styleHelper = require('../../helper/styleHelper');
var appTypes = require('../../types/appTypes');
var _ = require('underscore');

/**
 * 头像
 */
var AvatarEx = React.createClass({
  render: function () {
    var thickness = 1;
    var iconStyle = {};

    var shapeStyle = {
      borderVisible: styleHelper.getPropertyValue(this.props, 'borderVisible'),
      borderColor: styleHelper.getPropertyValue(this.props, 'borderColor'),
      shapeType: styleHelper.getPropertyValue(this.props, 'avatarShapeStyle'),
      color: this.props.avatarBackgroundColor,
      thickness: styleHelper.getPropertyValue(this.props, 'thickness'),
    };

    if (shapeStyle.shapeType === appTypes.AVATAR_SHAPE_STYLE.RECTANGLE) {
      shapeStyle.shapeType = appTypes.SHAPE_TYPE.RECTANGLE;
    } else if (shapeStyle.shapeType === appTypes.AVATAR_SHAPE_STYLE.CIRCLE) {
      shapeStyle.shapeType = appTypes.SHAPE_TYPE.ECLIPSE;
    }


    thickness = 1;
    if (this.props.borderVisible) {
      thickness = styleHelper.getPropertyValue(this.props, 'thickness') * 2;
    }

    if (shapeStyle.shapeType === appTypes.SHAPE_TYPE.RECTANGLE) {
      iconStyle.w = (styleHelper.getWidth(this.props) - thickness) * 0.85;
      iconStyle.h = (styleHelper.getHeight(this.props) - thickness) * 0.85;
      iconStyle.x = (styleHelper.getWidth(this.props) - iconStyle.w) / 2;
      iconStyle.y = styleHelper.getHeight(this.props) - iconStyle.h - thickness / 2;
    } else if (shapeStyle.shapeType === appTypes.SHAPE_TYPE.ECLIPSE) {
      iconStyle.w = (styleHelper.getWidth(this.props) - thickness) / 2 * Math.sqrt(2);
      iconStyle.h = (styleHelper.getHeight(this.props) - thickness) / 2 * Math.sqrt(2);
      iconStyle.x = styleHelper.getWidth(this.props) / 2 - iconStyle.w / 2;
      iconStyle.y = styleHelper.getHeight(this.props) / 2 - iconStyle.h / 2;
    }

    iconStyle.URL = this.props.URL;
    iconStyle.icon = this.props.icon;

    if (this.props.avatarColorStyle === appTypes.AVATAR_COLOR_STYLE.NORMAL) {
      iconStyle.color = styleHelper.getPropertyValue(this.props, 'avatarColor');
    } else if (this.props.avatarColorStyle === appTypes.AVATAR_COLOR_STYLE.BLACK) {
      iconStyle.color = '#000000';
      shapeStyle.color = '#FFFFFF';
    } else if (this.props.avatarColorStyle === appTypes.AVATAR_COLOR_STYLE.GRAY) {
      iconStyle.color = '#FFFFFF';
      shapeStyle.color = '#CCCCCC';
    }

    if (this.props.icon.iconCode === '62168' && this.props.icon.iconFontName === 'jdIonicons') {
      if (shapeStyle.shapeType === appTypes.SHAPE_TYPE.RECTANGLE) {
        iconStyle.w = Math.round(iconStyle.w * 9 / 7);
        iconStyle.h = Math.round(iconStyle.h * 9 / 7);
        iconStyle.x = Math.round((styleHelper.getWidth(this.props) - iconStyle.w) / 2);
        iconStyle.y = this.props.h - Math.round(iconStyle.h * 8 / 9) - thickness + 1;
      } else if (shapeStyle.shapeType === appTypes.SHAPE_TYPE.ECLIPSE) {
        iconStyle.w = Math.round(iconStyle.w * 9 / 7);
        iconStyle.h = Math.round(iconStyle.h * 9 / 7);
        iconStyle.x = Math.round((styleHelper.getWidth(this.props) - iconStyle.w) / 2  );
        iconStyle.y = this.props.h - Math.round(iconStyle.h) - thickness + 1;
      }
    }

    return (
      <div style={{
        width: '100%',
        height: '100%'
      }}>
        <ShapeParts {...shapeStyle}>
          <IconParts {...iconStyle}/>
        </ShapeParts>
      </div>
    );
  }
});

module.exports = AvatarEx;



// WEBPACK FOOTER //
// ./src/views/Components/AvatarEx2.jsx